import React from "react";
import PropTypes from "prop-types";
import RatingEmoji from "../RatingEmoji";
import {
  Wrapper,
  Rating,
  Input,
  Label,
  Title,
  StepCount,
} from "../styles/rating-steps-styles";

const Step2 = ({ setRating, rating }) => (
  <Wrapper noPointerEvents={rating}>
    <RatingEmoji rating={rating} />
    <Title className="animated delay fadeInDown">Quality of Submission</Title>
    <Rating className="rating animated delay fadeInDown">
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step2Rating"
        id="rating-25"
        value={5}
      />
      <Label htmlFor="rating-25" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step2Rating"
        id="rating-24"
        value={4}
      />
      <Label htmlFor="rating-24" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step2Rating"
        id="rating-23"
        value={3}
      />
      <Label htmlFor="rating-23" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step2Rating"
        id="rating-22"
        value={2}
      />
      <Label htmlFor="rating-22" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step2Rating"
        id="rating-21"
        value={1}
      />
      <Label htmlFor="rating-21" />
    </Rating>
    <StepCount>step 2 of 5</StepCount>
  </Wrapper>
);

Step2.propTypes = {
  setRating: PropTypes.func.isRequired,
  rating: PropTypes.number,
};

Step2.defaultProps = {
  rating: PropTypes.isNull,
};
export default Step2;
